export default __webpack_public_path__ + "static/media/iOS Safari.a9653688.svg";